export function getDateRange(monthsToAdd: number) {

  const today = new Date();
  const nextMonth = new Date(today.getFullYear(), today.getMonth() + monthsToAdd);

  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, '0'); // add leading zero if month is a single digit
  const day = today.getDate().toString().padStart(2, '0'); // add leading zero if day is a single digit

  const nextMonthYear = nextMonth.getFullYear();
  const nextMonthMonth = (nextMonth.getMonth() + 1).toString().padStart(2, '0');
  const dateFrom = `${year}-${month}-${day}`;
  const dateTo = `${nextMonthYear}-${nextMonthMonth}-${day}`;

  return { dateFrom, dateTo };
}

export function getTodaysDate() {

  const today = new Date();
  const day = today.getDate().toString().padStart(2, '0');
  const month = (today.getMonth() + 1).toString().padStart(2, '0');
  const year = today.getFullYear().toString();

  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
}